import { useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";
import Seo from "./Seo";
import JsonLd from "./JsonLd";
import { getSeoForPath } from "../config/seo";
import { siteGraphJsonLd } from "../utils/schema";

/**
 * Shared layout for all public pages: same Header + Footer everywhere.
 * Page content is rendered via <Outlet />. SEO meta is set per route.
 */
const PublicLayout = () => {
  const location = useLocation();
  const seo = getSeoForPath(location.pathname);
  const siteSchema = useMemo(
    () => siteGraphJsonLd(location.pathname, seo.title),
    [location.pathname, seo.title],
  );

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", bgcolor: "#fafafa" }}>
      <Seo
        title={seo.title}
        description={seo.description}
        canonicalPath={seo.path || location.pathname}
        image={seo.image ?? "/treasure-og-image.png"}
        imageAlt={seo.imageAlt || seo.title}
        noindex={seo.noindex}
        type={seo.type || "website"}
        publishedTime={seo.publishedTime}
        modifiedTime={seo.modifiedTime}
        keywords={seo.keywords}
      />
      <JsonLd data={siteSchema} id="jsonld-site" />
      <Header />
      <Box component="main" sx={{ flex: 1 }}>
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
};

export default PublicLayout;
